export function adminRouteParams(): URLSearchParams {
  const queryStart = window.location.hash.indexOf("?");

  if (!window.location.hash.startsWith("#/admin") || queryStart === -1) {
    return new URLSearchParams();
  }

  return new URLSearchParams(window.location.hash.slice(queryStart + 1));
}

export function replaceAdminRouteParams(
  updates: Readonly<Record<string, string | null>>,
): void {
  const params = adminRouteParams();

  Object.entries(updates).forEach(([key, value]) => {
    if (value === null) {
      params.delete(key);
      return;
    }

    params.set(key, value);
  });

  const query = params.toString();
  const nextHash = `#/admin${query ? `?${query}` : ""}`;

  if (window.location.hash !== nextHash) {
    window.history.replaceState(null, "", nextHash);
  }
}
